import React from 'react';

import {
  Box,
  Link,
  Stack,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  activityTemplates,
  AuthWrapper,
  routeDirectory
} from 'modules';

import * as dataService from './dataService';


export interface IDebugActivityProps {}

export const DebugActivity: React.FC<IDebugActivityProps> = props => {
  const { data } = dataService.useDebugActivity();

  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC>
        <Stack spacing={2}>
          <Typography variant="h2">App Info</Typography>

          <Box>
            <Typography>{window.screen.width}x{window.screen.height}</Typography>
            <Typography>Client Version: {process.env['REACT_APP_VERSION']}</Typography>
            <Typography>API Version: {data.version}</Typography>
            <Typography>Environment: {process.env['REACT_APP_ENV_NAME']}</Typography>
          </Box>

          <Typography variant="h2">
          User List
          </Typography>

          {_.map(data.users, user =>
            <Link
              key={user.id}
              href={routeDirectory.investorProfile.path(user.id)}>
              {user.fullName || 'NO NAME'} ({user.userType})
            </Link>
          )}

        </Stack>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
